import React, { useEffect, useState } from 'react'
import { isNull } from 'lodash'
import { useQuery } from 'react-query'
import { getReportTypes } from './api'

export const REPORT_SEVERITY = {
    infested: 'infested',
    warning: 'warning',
    critical: 'critical',
    info: 'info',
    inactive: 'inactive',
    down: 'down',
    catch: 'catch'
}

export const SEVERITY_THEME_COLOR_MAP = {
    [REPORT_SEVERITY.warning]: 'warning',
    [REPORT_SEVERITY.critical]: 'error',
    [REPORT_SEVERITY.info]: 'active',
    [REPORT_SEVERITY.inactive]: 'secondary',
    [REPORT_SEVERITY.down]: 'error',
    [REPORT_SEVERITY.catch]: 'error'
}

/**
 * Report types constants
 * 1. must be always in sync with Back-end constants
 * 2. must be always kept here in one place
 **/
export const REPORT_TYPES = {
    successfully_set_up: '0',
    restarted: '1',
    triggered: '2',
    rearmed: '3',
    heartbeat_missed: '4',
    down: '5',
    locating_now: '6',
    locating_fail: '7',
    settings_updated: '8',
    update_installed: '9',
    battery_low: '10',
    online_again: '11',
    turned_off: '12',
    unstable_connection: '13',
    infested: '14',
    light_infestation: '15',
    severe_infestation: '16',
    false_triggering: '17',
    activity_warning: '18',
    activity_critical: '19',
    catch: '20',
    activity_noticed: '21',
    activity_threshold_reached: '22',
    bait_low: '23',
    activity_threshold_reached_and_bait_low: '24',
    activity_threshold_reset: '25'
}

export const useReportTypes = reportType => {
    const { data, isLoading } = useQuery('reportDict', getReportTypes, {
        refetchInterval: false,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        onError: e => console.log('reports dictionary is not loaded')
    })
    const [severity, setSeverity] = useState()

    useEffect(() => {
        if (!data) return

        if (isNull(reportType) || reportType === undefined) {
            setSeverity(REPORT_SEVERITY.inactive)
            return
        }

        const reportSeverity = Object.keys(data).reduce((acc, cur) => {
            if (data[cur].includes(reportType)) {
                acc = cur
            }

            return acc
        })
        setSeverity(reportSeverity)
    }, [data, reportType])

    return {
        isLoading,
        severity,
        reportSeverityGroups: data
    }
}
